namespace $.$$ {

	export class $shm_hitalama_opencode_session extends $.$shm_hitalama_opencode_session {

		static messages_data_cache = new Map< string, $shm_hitalama_opencode_api_message[] >()
		static messages_loaded_cache = new Map< string, boolean >()
		static messages_missing_cache = new Map< string, boolean >()
		static message_delta_cache = new Map< string, {
			session_key: string
			session_id: string
			message_id: string
			part_id: string
			field: string
			delta: string
		} >()
		static message_delta_timer_cache = new Map< string, any >()

		@ $mol_mem_key
		static messages_version( key: string, next?: number ) {
			return next ?? 0
		}

		messages_cache_key( session_id: string ) {
			return `${ this.server_url() }|${ session_id }`
		}

		session_pages() {
			return [
				this.Chat_page(),
				... ( this.thinking_pending() || this.thinking_message_id() ? [ this.Thinking_page() ] : [] ),
			] as readonly $mol_view[]
		}

		@ $mol_mem
		providers_data() {
			this.providers_refresh()
			return $mol_wire_sync( this ).providers_data_async() as {
				providers: $shm_hitalama_opencode_api_provider[]
				default: Record< string, string >
			}
		}

		@ $mol_mem
		providers_refresh( next?: number ) {
			return next ?? 0
		}

		@ $mol_mem
		providers_data_async() {
			return $shm_hitalama_opencode_api.providers( this.server_url() )
		}

		providers() {
			return this.providers_data().providers ?? []
		}

		override provider_id( next?: string ) {
			if( next !== undefined ) return super.provider_id( next )
			const stored = super.provider_id()
			if( stored && this.provider_options().includes( stored ) ) return stored
			const configured = this.config_model()
			if( configured && this.provider_options().includes( configured.providerID ) ) return configured.providerID
			return this.provider_options()[0] ?? ''
		}

		provider_options() {
			return this.providers().map( provider => provider.id )
		}

		provider_dict() {
			const dict = {} as Record< string, string >
			for( const provider of this.providers() ) dict[ provider.id ] = provider.name || provider.id
			return dict
		}

		provider_current() {
			const selected = this.provider_id()
			const providers = this.providers()
			return providers.find( provider => provider.id === selected ) ?? providers[0]
		}

		model_options() {
			const models = this.provider_current()?.models ?? {}
			return Object.keys( models )
		}

		@ $mol_mem
		config_data() {
			return $mol_wire_sync( $shm_hitalama_opencode_api ).config_resolved( this.server_url() ) as $shm_hitalama_opencode_api_config
		}

		config_model() {
			const model = this.config_data().model
			if( typeof model !== 'string' ) return null
			const divider = model.indexOf( '/' )
			if( divider === -1 ) return null
			return {
				providerID: model.slice( 0, divider ),
				modelID: model.slice( divider + 1 ),
			}
		}

		override model_id( next?: string ) {
			if( next !== undefined ) return super.model_id( next )
			const stored = super.model_id()
			if( stored && this.model_options().includes( stored ) ) return stored
			const configured = this.config_model()
			if( configured?.providerID === this.provider_id() && this.model_options().includes( configured.modelID ) ) return configured.modelID
			const fallback = this.providers_data().default?.[ this.provider_id() ] ?? this.model_options()[0]
			return fallback ?? ''
		}

		model_dict() {
			const dict = {} as Record< string, string >
			const models = this.provider_current()?.models ?? {}
			for( const id in models ) dict[ id ] = models[ id ].name || id
			return dict
		}

		model_current() {
			const provider = this.provider_current()
			if( !provider ) return null
			return {
				providerID: provider.id,
				modelID: this.model_id(),
			}
		}

		chat_model_label() {
			const model = this.model_dict()[ this.model_id() ] || this.model_id()
			return model || 'Модель'
		}

		chat_model_hint() {
			const provider = this.provider_dict()[ this.provider_id() ] || this.provider_id()
			const model = this.chat_model_label()
			return [ provider, model ].filter( Boolean ).join( ' · ' )
		}

		override custom_provider_id( next?: string ) {
			return super.custom_provider_id( next ) || 'custom'
		}

		override custom_provider_name( next?: string ) {
			return super.custom_provider_name( next ) || this.custom_provider_id()
		}

		override custom_provider_base_url( next?: string ) {
			return super.custom_provider_base_url( next ) || 'http://127.0.0.1:1234/v1'
		}

		override custom_provider_model_id( next?: string ) {
			return super.custom_provider_model_id( next ) || 'model'
		}

		override custom_provider_model_name( next?: string ) {
			return super.custom_provider_model_name( next ) || this.custom_provider_model_id()
		}

		override custom_provider_add_content() {
			return [ 'Добавить провайдера' ]
		}

		@ $mol_action
		override custom_provider_add( next?: Event ) {
			if( next === undefined ) return null

			const data = {
				provider_id: this.custom_provider_id().trim(),
				provider_name: this.custom_provider_name().trim() || this.custom_provider_id().trim(),
				base_url: this.custom_provider_base_url().trim(),
				api_key: this.custom_provider_api_key().trim(),
				model_id: this.custom_provider_model_id().trim(),
				model_name: this.custom_provider_model_name().trim() || this.custom_provider_model_id().trim(),
			}

			if( !data.provider_id ) throw new Error( 'Provider ID is required' )
			if( !data.base_url ) throw new Error( 'Base URL is required' )
			if( !data.model_id ) throw new Error( 'Model ID is required' )

			$mol_wire_async( this ).custom_provider_add_later( data ).catch( error => $mol_fail_log( error ) )
			return next
		}

		custom_provider_add_later( data: {
			provider_id: string
			provider_name: string
			base_url: string
			api_key: string
			model_id: string
			model_name: string
		} ) {
			const {
				provider_id,
				provider_name,
				base_url,
				api_key,
				model_id,
				model_name,
			} = data

			const config = $mol_wire_sync( $shm_hitalama_opencode_api ).config( this.server_url() )
			const provider = config.provider?.[ provider_id ] ?? {}
			const options = {
				... provider.options,
				baseURL: base_url,
				...( api_key ? { apiKey: api_key } : {} ),
			}
			const models = {
				... provider.models,
				[ model_id ]: {
					... ( provider.models?.[ model_id ] ?? {} ),
					name: model_name,
				},
			}

			$mol_wire_sync( $shm_hitalama_opencode_api ).config_update( this.server_url(), {
				... config,
				provider: {
					... config.provider,
					[ provider_id ]: {
						... provider,
						npm: provider.npm ?? '@ai-sdk/openai-compatible',
						name: provider_name,
						options,
						models,
					},
				},
			} )

			this.providers_refresh( Date.now() )
			this.provider_id( provider_id )
			this.model_id( model_id )
			this.custom_provider_expanded( false )
		}

		@ $mol_action
		load_messages( session_id = this.session_id(), force = false ) {
			if( !session_id ) return
			if( !force && this.messages_loaded( session_id ) ) return
			if( this.messages_loading( session_id ) ) return
			if( !force && this.messages_missing( session_id ) ) return
			this.messages_loading( session_id, true )
			if( force ) this.messages_missing( session_id, false )
			$shm_hitalama_opencode_api.messages( this.server_url(), session_id )
				.then( messages => {
					this.messages_data( session_id, this.messages_merge_loaded(
						session_id,
						messages as $shm_hitalama_opencode_api_message[],
					) )
					this.messages_loaded( session_id, true )
					this.messages_missing( session_id, false )
				} )
				.catch( error => {
					if( error instanceof $shm_hitalama_opencode_api_error && error.status === 404 ) {
						this.messages_data( session_id, [] )
						this.messages_loaded( session_id, true )
						this.messages_missing( session_id, true )
						return
					}
					this.messages_loaded( session_id, true )
					$mol_fail_log( error )
				} )
				.finally( ()=> this.messages_loading( session_id, false ) )
		}

		@ $mol_mem_key
		messages_data( session_id: string, next?: $shm_hitalama_opencode_api_message[] ) {
			const key = this.messages_cache_key( session_id )
			if( next !== undefined ) {
				$shm_hitalama_opencode_session.messages_data_cache.set( key, next )
				$shm_hitalama_opencode_session.messages_version( key, Date.now() )
				return next
			}
			$shm_hitalama_opencode_session.messages_version( key )
			return $shm_hitalama_opencode_session.messages_data_cache.get( key ) ?? [] as $shm_hitalama_opencode_api_message[]
		}

		messages_merge_loaded( session_id: string, loaded: $shm_hitalama_opencode_api_message[] ) {
			const local = this.messages_cached( session_id ).filter( message => {
				if( !this.message_is_local_user( message ) ) return false
				const text = this.message_plain_text( message )
				return !loaded.some( item => this.message_is_user( item ) && this.message_plain_text( item ) === text )
			} )
			if( !local.length ) return loaded

			return [ ... loaded, ... local ].sort( ( left, right )=> {
				return this.message_sort_time( left ) - this.message_sort_time( right )
			} )
		}

		message_sort_time( message: $shm_hitalama_opencode_api_message ) {
			return Number( message.info.time?.created ?? 0 )
		}

		@ $mol_mem_key
		messages_loaded( session_id: string, next?: boolean ) {
			const key = this.messages_cache_key( session_id )
			if( next !== undefined ) {
				$shm_hitalama_opencode_session.messages_loaded_cache.set( key, next )
				return next
			}
			return $shm_hitalama_opencode_session.messages_loaded_cache.get( key ) ?? false
		}

		@ $mol_mem_key
		messages_loading( session_id: string, next?: boolean ) {
			return next ?? false
		}

		@ $mol_mem_key
		messages_missing( session_id: string, next?: boolean ) {
			const key = this.messages_cache_key( session_id )
			if( next !== undefined ) {
				$shm_hitalama_opencode_session.messages_missing_cache.set( key, next )
				return next
			}
			return $shm_hitalama_opencode_session.messages_missing_cache.get( key ) ?? false
		}

		@ $mol_mem_key
		session_busy( session_id: string, next?: boolean ) {
			return next ?? false
		}

		session_event_status( session_id: string, type: string, props?: any ) {
			const status = String(
				props?.status
				?? props?.state?.status
				?? props?.info?.status
				?? '',
			).toLowerCase()

			if(
				type === 'session.idle'
				|| type === 'session.error'
				|| status === 'idle'
				|| status === 'error'
				|| status === 'stopped'
				|| status === 'complete'
				|| status === 'completed'
			) {
				this.session_busy( session_id, false )
			}
		}

		session_busy_sync_messages( session_id: string, messages: $shm_hitalama_opencode_api_message[] ) {
			if( !this.session_busy( session_id ) ) return

			const user_index = messages.findLastIndex( message => this.message_is_user( message ) )
			if( user_index === -1 ) return

			const complete = messages.slice( user_index + 1 ).some( message => {
				if( !this.message_is_assistant( message ) ) return false
				if( !this.message_is_complete( message ) ) return false

				for( const part of message.parts ) {
					if( part.type === 'step-start' ) return false
					if( part.type === 'step-finish' ) return false
					if( part.type === 'tool' ) return false
				}

				return !message.parts.some( part => {
					const status = String(
						part?.state?.status
						?? part?.status
						?? '',
					).toLowerCase()

					return status === 'running'
						|| status === 'pending'
						|| status === 'queued'
						|| status === 'started'
						|| status === 'in_progress'
				} )
			} )
			if( complete ) this.session_busy( session_id, false )
		}

		messages_ensure( session_id: string ) {
			if( this.messages_loaded( session_id ) ) return
			if( this.messages_loading( session_id ) ) return
			this.load_messages( session_id )
		}

		messages() {
			const session_id = this.session_id()
			if( !session_id ) return [] as $shm_hitalama_opencode_api_message[]
			this.messages_ensure( session_id )
			this.questions_ensure()
			const messages = this.messages_data( session_id )
			this.session_busy_sync_messages( session_id, messages )
			this.thinking_pending_autoselect( messages )
			this.thinking_autoselect( messages )
			this.messages_scroll_on_change( session_id, messages )
			return messages
		}

		@ $mol_mem_key
		messages_scroll_stamp( session_id: string, next?: string ) {
			return next ?? ''
		}

		@ $mol_mem_key
		messages_new( session_id: string, next?: boolean ) {
			return next ?? false
		}

		@ $mol_mem_key
		messages_down_visible( session_id: string, next?: boolean ) {
			return next ?? false
		}

		@ $mol_mem_key
		messages_stick_bottom( session_id: string, next?: boolean ) {
			return next ?? true
		}

		messages_scroll_on_change( session_id: string, messages: $shm_hitalama_opencode_api_message[] ) {
			const stamp = this.messages_stamp( messages )
			const prev = this.messages_scroll_stamp( session_id )
			if( stamp === prev ) return

			const should_scroll = !prev || ( this.messages_stick_bottom( session_id ) && this.messages_near_bottom() )
			this.messages_scroll_stamp( session_id, stamp )

			if( should_scroll ) {
				this.messages_new( session_id, false )
				this.messages_down_visible( session_id, false )
				new this.$.$mol_after_frame( ()=> this.messages_scroll_bottom() )
			} else {
				this.messages_new( session_id, true )
				this.messages_down_visible( session_id, true )
			}
		}

		messages_scroll_bottom() {
			const node = this.Messages().dom_node()
			this.scroll_bottom_node( node )
			if( this.session_id() ) this.messages_down_visible( this.session_id(), false )
		}

		messages_near_bottom() {
			const node = this.Messages().dom_node()
			return node.scrollHeight - node.scrollTop - node.clientHeight < 32
		}

		override messages_scroll( next?: Event ) {
			if( next === undefined ) return null
			const stick = this.messages_near_bottom()
			if( this.session_id() ) this.messages_stick_bottom( this.session_id(), stick )
			if( this.session_id() ) this.messages_down_visible( this.session_id(), !stick )
			if( stick && this.session_id() ) {
				this.messages_new( this.session_id(), false )
				this.messages_down_visible( this.session_id(), false )
			}
			return next
		}

		override messages_to_bottom( next?: Event ) {
			if( next === undefined ) return null
			new this.$.$mol_after_frame( ()=> {
				this.messages_scroll_bottom()
				if( this.session_id() ) this.messages_stick_bottom( this.session_id(), true )
				if( this.session_id() ) this.messages_new( this.session_id(), false )
				if( this.session_id() ) this.messages_down_visible( this.session_id(), false )
			} )
			return next
		}

		Messages_new() {
			const session_id = this.session_id()
			return session_id && this.messages_down_visible( session_id ) ? super.Messages_new() : null as any
		}

		messages_stamp( messages: $shm_hitalama_opencode_api_message[] ) {
			const last = messages[ messages.length - 1 ]
			const last_part = last?.parts[ last.parts.length - 1 ]
			return [
				messages.length,
				last?.info.id,
				last?.parts.length,
				last_part?.id,
				last_part?.type,
				last_part?.text?.length,
			].join( '|' )
		}

		@ $mol_action
		load_messages_later( session_id: string, delay = 50, force = false ) {
			new this.$.$mol_after_timeout( delay, ()=> this.load_messages( session_id, force ) )
		}

		@ $mol_action
		load_messages_soon( session_id: string ) {
			for( const delay of [ 50, 250, 1000, 3000, 6000 ] ) this.load_messages_later( session_id, delay, true )
		}

		@ $mol_action
		message_local_user_upsert( session_id: string, text: string ) {
			const messages = this.messages_cached( session_id )
			const last = messages[ messages.length - 1 ]
			const last_text = last?.parts.map( part => this.part_text( part ) ).filter( Boolean ).join( '\n\n' )
			if( last && this.message_is_user( last ) && last_text === text ) return

			const now = Date.now()
			this.messages_data( session_id, [
				... messages,
				{
					info: {
						id: `local-user-${ now }`,
						sessionID: session_id,
						role: 'user',
						agent: this.agent_id(),
						model: this.model_current() ?? undefined,
						time: { created: now },
					},
					parts: [
						{
							id: `local-user-${ now }-text`,
							type: 'text',
							text,
						},
					],
				},
			] )
		}

		message_is_local_user( message: $shm_hitalama_opencode_api_message ) {
			return this.message_is_user( message ) && message.info.id.startsWith( 'local-user-' )
		}

		message_plain_text( message: $shm_hitalama_opencode_api_message ) {
			return message.parts.map( part => this.part_text( part ) ).filter( Boolean ).join( '\n\n' )
		}

		message_info_upsert( session_id: string, info: $shm_hitalama_opencode_api_message['info'] ) {
			if( !session_id || !info?.id ) return
			this.message_delta_flush( session_id )
			const messages = this.messages_cached( session_id )
			const index = messages.findIndex( message => message.info.id === info.id )
			const message = {
				info: { ... messages[ index ]?.info, ... info },
				parts: messages[ index ]?.parts ?? [],
			}
			const next = index === -1
				? [ ... messages, message ]
				: [ ... messages.slice( 0, index ), message, ... messages.slice( index + 1 ) ]
			this.messages_data( session_id, next )
			if( session_id === this.session_id() && this.message_is_assistant( message ) && this.thinking_open_on_message() ) {
				if( this.thinking_message_id() === 'pending' || !this.thinking_message_id() ) {
					this.thinking_message_id( message.info.id )
				}
			}
		}

		message_remove( session_id: string, message_id: string ) {
			this.message_delta_flush( session_id )
			const messages = this.messages_cached( session_id )
			this.messages_data( session_id, messages.filter( message => message.info.id !== message_id ) )
		}

		message_part_upsert( session_id: string, part: any ) {
			const message_id = part?.messageID
			if( !session_id || !message_id || !part?.id ) return
			this.message_delta_flush( session_id )

			this.message_info_upsert( session_id, {
				id: message_id,
				sessionID: session_id,
				role: 'assistant',
				time: { created: Date.now() },
			} )

			const messages = this.messages_cached( session_id )
			const message_index = messages.findIndex( message => message.info.id === message_id )
			if( message_index === -1 ) return

			const message = messages[ message_index ]
			const part_index = message.parts.findIndex( item => item.id === part.id )
			const parts = part_index === -1
				? [ ... message.parts, part ]
				: [ ... message.parts.slice( 0, part_index ), { ... message.parts[ part_index ], ... part }, ... message.parts.slice( part_index + 1 ) ]
			this.messages_data( session_id, [
				... messages.slice( 0, message_index ),
				{ ... message, parts },
				... messages.slice( message_index + 1 ),
			] )
		}

		message_part_remove( session_id: string, message_id: string, part_id: string ) {
			this.message_delta_flush( session_id )
			const messages = this.messages_cached( session_id )
			const message_index = messages.findIndex( message => message.info.id === message_id )
			if( message_index === -1 ) return
			const message = messages[ message_index ]
			this.messages_data( session_id, [
				... messages.slice( 0, message_index ),
				{ ... message, parts: message.parts.filter( part => part.id !== part_id ) },
				... messages.slice( message_index + 1 ),
			] )
		}

		message_part_delta( session_id: string, message_id: string, part_id: string, field: string, delta: string ) {
			if( !session_id || !message_id || !part_id || !field || !delta ) return

			const messages = this.messages_cached( session_id )
			const message_index = messages.findIndex( message => message.info.id === message_id )
			if( message_index === -1 ) {
				this.message_delta_apply( session_id, message_id, part_id, field, '' )
			}

			const session_key = this.messages_cache_key( session_id )
			const key = [ session_key, message_id, part_id, field ].join( '|' )
			const prev = $shm_hitalama_opencode_session.message_delta_cache.get( key )
			$shm_hitalama_opencode_session.message_delta_cache.set( key, {
				session_key,
				session_id,
				message_id,
				part_id,
				field,
				delta: `${ prev?.delta ?? '' }${ delta }`,
			} )
			this.message_delta_schedule( session_id )
		}

		message_delta_schedule( session_id: string ) {
			const session_key = this.messages_cache_key( session_id )
			if( $shm_hitalama_opencode_session.message_delta_timer_cache.has( session_key ) ) return

			const timer = new this.$.$mol_after_timeout( 200, ()=> this.message_delta_flush( session_id ) )
			$shm_hitalama_opencode_session.message_delta_timer_cache.set( session_key, timer )
		}

		@ $mol_action
		message_delta_flush( session_id: string ) {
			const session_key = this.messages_cache_key( session_id )
			$shm_hitalama_opencode_session.message_delta_timer_cache.delete( session_key )

			const pending = [ ... $shm_hitalama_opencode_session.message_delta_cache ].filter( ([ _, item ])=> item.session_key === session_key )
			if( !pending.length ) return

			let messages = this.messages_cached( session_id )
			for( const [ key, item ] of pending ) {
				$shm_hitalama_opencode_session.message_delta_cache.delete( key )
				messages = this.message_delta_apply_to( messages, session_id, item.message_id, item.part_id, item.field, item.delta )
			}
			this.messages_data( session_id, messages )
		}

		message_delta_apply( session_id: string, message_id: string, part_id: string, field: string, delta: string ) {
			const messages = this.message_delta_apply_to( this.messages_cached( session_id ), session_id, message_id, part_id, field, delta )
			this.messages_data( session_id, messages )
		}

		message_delta_apply_to( messages: $shm_hitalama_opencode_api_message[], session_id: string, message_id: string, part_id: string, field: string, delta: string ) {
			const message_index = messages.findIndex( message => message.info.id === message_id )
			if( message_index === -1 ) return [
				... messages,
				{
					info: {
						id: message_id,
						sessionID: session_id,
						role: 'assistant',
						time: { created: Date.now() },
					},
					parts: [
						{
							id: part_id,
							messageID: message_id,
							type: 'text',
							[ field ]: delta,
						},
					],
				},
			]

			const message = messages[ message_index ]
			const part_index = message.parts.findIndex( part => part.id === part_id )
			const part = part_index === -1
				? { id: part_id, messageID: message_id, sessionID: session_id, type: 'text' }
				: message.parts[ part_index ]
			const next_part = {
				... part,
				[ field ]: `${ part[ field ] ?? '' }${ delta }`,
			}
			const parts = part_index === -1
				? [ ... message.parts, next_part ]
				: [ ... message.parts.slice( 0, part_index ), next_part, ... message.parts.slice( part_index + 1 ) ]
			return [
				... messages.slice( 0, message_index ),
				{ ... message, parts },
				... messages.slice( message_index + 1 ),
			]
		}

		messages_cached( session_id: string ) {
			return $mol_wire_probe( ()=> this.messages_data( session_id ) ) ?? [] as $shm_hitalama_opencode_api_message[]
		}

		@ $mol_action
		load_questions() {
			if( this.questions_loaded() ) return
			if( this.questions_loading() ) return
			this.questions_loading( true )
			$shm_hitalama_opencode_api.questions( this.server_url() )
				.then( questions => {
					this.questions_data( questions as $shm_hitalama_opencode_api_question[] )
					this.questions_loaded( true )
				} )
				.catch( error => {
					this.questions_loaded( true )
					$mol_fail_log( error )
				} )
				.finally( ()=> this.questions_loading( false ) )
		}

		@ $mol_mem
		questions_data( next?: $shm_hitalama_opencode_api_question[] ) {
			return next ?? [] as $shm_hitalama_opencode_api_question[]
		}

		@ $mol_mem
		questions_loaded( next?: boolean ) {
			return next ?? false
		}

		@ $mol_mem
		questions_loading( next?: boolean ) {
			return next ?? false
		}

		questions_ensure() {
			if( this.questions_loaded() ) return
			if( this.questions_loading() ) return
			this.load_questions()
		}

		questions() {
			this.questions_ensure()
			const session_id = this.session_id()
			return this.questions_data().filter( question => !session_id || question.sessionID === session_id )
		}

		question_upsert( question: $shm_hitalama_opencode_api_question ) {
			if( !question?.id ) return
			const questions = this.questions_data()
			const index = questions.findIndex( item => item.id === question.id )
			const next = index === -1
				? [ ... questions, question ]
				: [ ... questions.slice( 0, index ), { ... questions[ index ], ... question }, ... questions.slice( index + 1 ) ]
			this.questions_data( next )
			this.questions_loaded( true )
		}

		question_remove( request_id: string ) {
			if( !request_id ) return
			this.questions_data( this.questions_data().filter( question => question.id !== request_id ) )
		}

		question_by_tool_part( part: any ) {
			const session_id = this.session_id()
			return this.questions().find( question => {
				if( session_id && question.sessionID !== session_id ) return false
				if( part.callID && question.tool?.callID === part.callID ) return true
				if( part.messageID && question.tool?.messageID === part.messageID ) return true
				return false
			} ) ?? null
		}

		view_raw() {
			return this.view_mode() === 'raw'
		}

		chat_title() {
			return `Чат (${ this.displayed_messages().length })`
		}

		token_message() {
			return [ ... this.messages() ].reverse().find( message => {
				return this.message_is_assistant( message ) && !!this.message_tokens( message )
			} ) ?? null
		}

		message_tokens( message: $shm_hitalama_opencode_api_message ) {
			return message.info.tokens
				?? [ ... message.parts ].reverse().find( part => part.tokens )?.tokens
				?? null
		}

		token_model_limit( message = this.token_message() ) {
			if( !message ) return null
			const model_id = message?.info.modelID || message?.info.model?.modelID || message?.info.model?.id || this.model_id()
			const provider_id = message?.info.providerID || message?.info.model?.providerID || this.provider_id()
			const provider = this.providers().find( item => item.id === provider_id ) ?? this.provider_current()
			const model = provider?.models?.[ model_id ]
			return model?.limit ?? null
		}

		context_label() {
			const message = this.token_message()
			const tokens = message && this.message_tokens( message )
			const total = tokens?.total
			if( !total ) return 'Контекст: —'

			const limit = this.token_model_limit( message )?.context
			if( !limit ) return `Контекст: ${ this.tokens_format( total ) }`
			return `Контекст: ${ this.tokens_format( total ) } / ${ this.tokens_format( limit ) }`
		}

		context_hint() {
			const message = this.token_message()
			const tokens = message && this.message_tokens( message )
			if( !tokens ) return 'Токены появятся после ответа ассистента'

			const limit = this.token_model_limit( message )
			const rows = [
				`Всего: ${ this.tokens_format( tokens.total ?? 0 ) }`,
				`Вход: ${ this.tokens_format( tokens.input ?? 0 ) }`,
				`Выход: ${ this.tokens_format( tokens.output ?? 0 ) }`,
				`Размышления: ${ this.tokens_format( tokens.reasoning ?? 0 ) }`,
				`Кэш чтение: ${ this.tokens_format( tokens.cache?.read ?? 0 ) }`,
				`Кэш запись: ${ this.tokens_format( tokens.cache?.write ?? 0 ) }`,
			]
			if( limit?.context ) rows.unshift( `Лимит контекста: ${ this.tokens_format( limit.context ) }` )
			if( limit?.output ) rows.push( `Лимит ответа: ${ this.tokens_format( limit.output ) }` )
			return rows.join( '\n' )
		}

		context_usage_level() {
			const message = this.token_message()
			const tokens = message && this.message_tokens( message )
			const total = tokens?.total ?? 0
			if( !total ) return 'unknown'

			const context = this.token_model_limit( message )?.context ?? 0
			if( !context ) return 'unknown'
			const ratio = total / context
			if( ratio >= .85 ) return 'high'
			if( ratio >= .6 ) return 'medium'
			return 'low'
		}

		tokens_format( value: number ) {
			if( value >= 1_000_000 ) return `${ ( value / 1_000_000 ).toFixed( 1 ).replace( /\.0$/, '' ) }m`
			if( value >= 1_000 ) return `${ ( value / 1_000 ).toFixed( 1 ).replace( /\.0$/, '' ) }k`
			return String( value )
		}

		displayed_messages() {
			return this.view_raw() ? this.messages() : this.chat_messages()
		}

		message_rows() {
			return this.displayed_messages().map( message => this.Message_row( message.info.id ) )
		}

		chat_messages() {
			const visible = [] as $shm_hitalama_opencode_api_message[]
			let final_assistant = null as $shm_hitalama_opencode_api_message | null
			let pending_assistant = null as $shm_hitalama_opencode_api_message | null

			for( const message of this.messages() ) {
				if( !this.message_visible_in_chat( message ) ) continue

				if( this.message_is_user( message ) ) {
					if( final_assistant ) visible.push( final_assistant )
					else if( pending_assistant && this.message_step_text( pending_assistant ) ) {
						visible.push( this.message_step_card( pending_assistant ) )
					}
					final_assistant = null
					pending_assistant = null
					visible.push( message )
					continue
				}

				if( this.message_is_assistant( message ) && this.message_has_final_text( message ) ) {
					final_assistant = message
					pending_assistant = null
					continue
				}

				if( this.message_is_assistant( message ) && this.message_error_text( message ) ) {
					final_assistant = message
					pending_assistant = null
					continue
				}

				if( this.message_is_assistant( message ) ) {
					pending_assistant = message
				}
			}

			if( final_assistant ) visible.push( final_assistant )
			else if( pending_assistant && this.message_step_text( pending_assistant ) ) visible.push( this.message_step_card( pending_assistant ) )
			return visible
		}

		message_visible_in_chat( message: $shm_hitalama_opencode_api_message ) {
			return true
		}

		message_by_id( id: string ) {
			if( this.message_is_step_card_id( id ) ) return this.message_step_card_source( id )
			return this.messages().find( message => message.info.id === id )
		}

		message_is_step_card_id( id: string ) {
			return id.startsWith( 'step-card:' )
		}

		message_step_card_id( message: $shm_hitalama_opencode_api_message ) {
			return `step-card:${ message.info.id }`
		}

		message_step_card_source( id: string ) {
			const source = id.slice( 'step-card:'.length )
			return this.messages().find( message => message.info.id === source )
		}

		message_step_card( message: $shm_hitalama_opencode_api_message ) {
			return {
				info: {
					... message.info,
					id: this.message_step_card_id( message ),
					role: 'assistant_step',
				},
				parts: message.parts,
			} as $shm_hitalama_opencode_api_message
		}

		Message_thinking( id: string ) {
			const message = this.message_by_id( id )
			if( !message ) return null as any
			if( !this.message_is_assistant( message ) && !this.message_is_pending_user( message ) ) return null as any
			return super.Message_thinking( id )
		}

		message_thinking_arg( id: string ) {
			const thinking = this.message_is_step_card_id( id )
				? id.slice( 'step-card:'.length )
				: this.message_is_pending_user_id( id ) ? 'pending' : id
			return {
				session: this.session_id(),
				thinking,
			}
		}

		message_thinking_title( id: string ) {
			if( this.message_is_pending_user_id( id ) ) return 'Размышления'
			const source = this.message_is_step_card_id( id ) ? id.slice( 'step-card:'.length ) : id
			const count = this.thinking_steps_for_message_id( source ).length
			return `Размышления (${ count })`
		}

		message_is_assistant( message: $shm_hitalama_opencode_api_message ) {
			return message.info.role === 'assistant' || message.info.type === 'assistant'
		}

		message_is_user( message: $shm_hitalama_opencode_api_message ) {
			return message.info.role === 'user' || message.info.type === 'user'
		}

		message_has_final_text( message: $shm_hitalama_opencode_api_message ) {
			return message.parts.some( part => part.type === 'text' && ( part.text ?? '' ).trim() )
		}

		message_error_text( message: $shm_hitalama_opencode_api_message ) {
			return message.info.error?.data?.message ?? message.info.error?.message ?? ''
		}

		message_is_complete( message: $shm_hitalama_opencode_api_message ) {
			return Boolean( message.info.time?.completed )
		}

		message_is_pending_user_id( id: string ) {
			const message = this.message_by_id( id )
			return !!message && this.message_is_pending_user( message )
		}

		message_is_pending_user( message: $shm_hitalama_opencode_api_message ) {
			if( !this.thinking_pending() ) return false
			if( !this.message_is_user( message ) ) return false
			if( this.pending_final_assistant( this.messages() ) ) return false
			return message.info.id === this.pending_user( this.messages() )?.info.id
		}

		message_theme( id: string ) {
			if( this.message_role_key( id ) !== 'user' ) return '$mol_theme_special'
			return ''
		}

		message_role_key( id: string ) {
			if( this.message_is_step_card_id( id ) ) return 'assistant_step'
			const message = this.message_by_id( id )
			return message?.info.role || message?.info.type || ''
		}

		message_role( id: string ) {
			if( this.message_is_step_card_id( id ) ) return this.message_step_title_by_id( id )
			const info = this.message_by_id( id )?.info
			const role = info?.role || info?.type || ''
			const model = info?.model?.modelID || info?.model?.id
			return model ? `${ role } · ${ model }` : role
		}

		message_time( id: string ) {
			const time = this.message_by_id( id )?.info.time?.created
			if( !time ) return ''
			return new Date( time ).toLocaleString()
		}

		message_text( id: string ) {
			if( this.message_is_step_card_id( id ) ) return this.message_step_text_by_id( id )
			const message = this.message_by_id( id )
			if( !message ) return ''
			const parts = this.message_is_assistant( message ) && !this.view_raw()
				? message.parts.filter( part => part.type === 'text' )
				: message.parts
			const text = parts.map( part => this.part_text( part ) ).filter( Boolean )
			const error = this.message_error_text( message )
			if( error ) text.push( `Ошибка: ${ error }` )
			return text.join( '\n\n' )
		}

		Message_question_options( id: string ) {
			return this.message_question_option_rows( id ).length ? super.Message_question_options( id ) : null as any
		}

		message_question_option_rows( id: string ) {
			const message = this.message_by_id( id )
			if( !message ) return []
			return message.parts.flatMap( part => {
				if( part.type !== 'tool' || ( part.tool || part.name ) !== 'question' ) return []
				const request = this.question_by_tool_part( part )
				if( !request ) return []
				return request.questions.flatMap( ( question, question_index )=> {
					return question.options.map( ( option, option_index )=> {
						return this.Message_question_option( `${ request.id }:${ question_index }:${ option_index }` )
					} )
				} )
			} )
		}

		message_question_option_title( key: string ) {
			return this.question_option_title( key )
		}

		override message_question_option_reply( key: string, next?: Event ) {
			return this.question_option_reply( key, next )
		}

		message_step_text_by_id( id: string ) {
			const message = this.message_step_card_source( id )
			return message ? this.message_step_text( message ) : ''
		}

		message_step_title_by_id( id: string ) {
			const message = this.message_step_card_source( id )
			if( !message ) return 'assistant'
			const steps = this.thinking_steps_for( message )
			const step = steps[ steps.length - 1 ]
			if( !step ) return 'assistant'
			const status = step.finished ? 'завершён' : 'идёт'
			return `${ step.title } · ${ status }`
		}

		message_step_text( message: $shm_hitalama_opencode_api_message ) {
			const steps = this.thinking_steps_for( message )
			const step = steps[ steps.length - 1 ]
			if( !step ) return ''
			const text = [ ... step.parts ].reverse()
				.find( part => part.type !== 'step-start' && part.type !== 'step-finish' )
			const body = text?.type === 'tool'
				? this.tool_step_text( text )
				: text ? this.thinking_part_text_line( text ) : ''
			return body
		}

		thinking_open_on_message() {
			return true
		}

		@ $mol_mem
		thinking_message_id( next?: string ) {
			return this.$.$mol_state_arg.value(
				'thinking',
				next === undefined ? undefined : next || null,
			) ?? ''
		}

		@ $mol_mem
		thinking_pending( next?: boolean ) {
			return next ?? false
		}

		@ $mol_mem
		thinking_anchor_index( next?: number ) {
			return next ?? 0
		}

		thinking_pending_autoselect( messages: $shm_hitalama_opencode_api_message[] ) {
			if( !this.thinking_pending() ) return

			const assistant = this.pending_assistant( messages )
			if( assistant && this.thinking_message_id() === 'pending' ) {
				this.thinking_message_id( assistant.info.id )
			}

			if( this.pending_final_assistant( messages ) ) this.thinking_pending( false )
		}

		thinking_autoselect( messages: $shm_hitalama_opencode_api_message[] ) {
			if( this.thinking_pending() ) return
			const selected = this.thinking_message_id()
			if( selected && messages.some( message => message.info.id === selected ) ) return
			if( selected ) this.thinking_message_id( '' )
		}

		thinking_message() {
			const id = this.thinking_message_id()
			if( !id ) return null
			if( id === 'pending' ) return this.pending_assistant( this.messages() )
			return this.messages().find( message => message.info.id === id ) ?? null
		}

		thinking_status() {
			if( this.thinking_pending() && !this.thinking_message() ) return 'Жду новый ответ ассистента'
			const message = this.thinking_message()
			if( !message ) return 'Выбери ответ ассистента в чате'
			const time = message.info.time?.created
				? new Date( message.info.time.created ).toLocaleString()
				: ''
			const model = message.info.model?.modelID || message.info.model?.id || message.info.modelID
			return [ 'Ответ ассистента', model, time ].filter( Boolean ).join( ' · ' )
		}

		pending_user( messages: $shm_hitalama_opencode_api_message[] ) {
			const anchor = this.thinking_anchor_index()
			return messages.slice( anchor ).find( message => this.message_is_user( message ) ) ?? null
		}

		pending_assistant( messages: $shm_hitalama_opencode_api_message[] ) {
			const anchor = this.thinking_anchor_index()
			return messages.slice( anchor ).find( message => this.message_is_assistant( message ) ) ?? null
		}

		pending_final_assistant( messages: $shm_hitalama_opencode_api_message[] ) {
			const anchor = this.thinking_anchor_index()
			return messages.slice( anchor ).find( message => {
				return this.message_is_assistant( message ) && this.message_has_final_text( message )
			} ) ?? null
		}

		thinking_step_rows() {
			const steps = this.thinking_steps()
			this.thinking_scroll_on_change( this.thinking_message_id(), steps )
			return steps.map( ( step, index )=> this.Thinking_part_row( `${ index }` ) )
		}

		thinking_messages() {
			const message = this.thinking_message()
			if( !message ) return [] as any[]
			return this.thinking_messages_for( message )
		}

		thinking_messages_for( message: $shm_hitalama_opencode_api_message ) {
			const messages = this.messages()
			const selected_index = messages.findIndex( item => item.info.id === message.info.id )
			if( selected_index === -1 ) return [ message ]

			let start = selected_index
			while( start > 0 && !this.message_is_user( messages[ start - 1 ] ) ) --start
			if( start > 0 && this.message_is_user( messages[ start - 1 ] ) ) --start

			let finish = selected_index
			while( finish + 1 < messages.length && !this.message_is_user( messages[ finish + 1 ] ) ) ++finish

			return messages.slice( start, finish + 1 ).filter( item => this.message_is_assistant( item ) )
		}

		thinking_steps() {
			const message = this.thinking_message()
			return message ? this.thinking_steps_for( message ) : []
		}

		thinking_steps_for_message_id( id: string ) {
			const message = this.message_by_id( id )
			return message ? this.thinking_steps_for( message ) : []
		}

		thinking_steps_for( message: $shm_hitalama_opencode_api_message ) {
			const steps = [] as { title: string; parts: any[]; finished: boolean }[]
			let current = null as { title: string; parts: any[]; finished: boolean } | null

			const ensure = ()=> current ?? ( current = {
				title: 'Подготовка',
				parts: [],
				finished: false,
			} )

			for( const item of this.thinking_messages_for( message ) ) {
				for( const part of item.parts ) {
					if( part.type === 'text' ) continue

					if( part.type === 'step-start' ) {
						if( current ) steps.push( current )
						current = {
							title: `Шаг ${ steps.length + 1 }`,
							parts: [ part ],
							finished: false,
						}
						continue
					}

					if( part.type === 'step-finish' ) {
						const step = ensure()
						step.parts.push( part )
						step.finished = true
						steps.push( step )
						current = null
						continue
					}

					ensure().parts.push( part )
				}
			}

			if( current ) steps.push( current )
			return steps.filter( step => step.parts.some( part => part.type !== 'step-start' && part.type !== 'step-finish' ) )
		}

		@ $mol_mem_key
		thinking_scroll_stamp( id: string, next?: string ) {
			return next ?? ''
		}

		@ $mol_mem_key
		thinking_stick_bottom( id: string, next?: boolean ) {
			return next ?? true
		}

		@ $mol_mem_key
		thinking_down_visible( id: string, next?: boolean ) {
			return next ?? false
		}

		thinking_scroll_on_change( id: string, steps: { title: string; parts: any[]; finished: boolean }[] ) {
			if( !id ) return
			const stamp = this.thinking_steps_stamp( steps )
			const prev = this.thinking_scroll_stamp( id )
			if( stamp === prev ) return

			const should_scroll = !prev || ( this.thinking_stick_bottom( id ) && this.thinking_near_bottom() )
			this.thinking_scroll_stamp( id, stamp )
			if( should_scroll ) {
				this.thinking_down_visible( id, false )
				new this.$.$mol_after_frame( ()=> this.thinking_scroll_bottom() )
			} else {
				this.thinking_down_visible( id, true )
			}
		}

		thinking_steps_stamp( steps: { title: string; parts: any[]; finished: boolean }[] ) {
			const last = steps[ steps.length - 1 ]
			const part = last?.parts[ last.parts.length - 1 ]
			return [
				steps.length,
				last?.parts.length,
				last?.finished,
				part?.id,
				part?.type,
				part?.text?.length,
				part?.state?.status,
			].join( '|' )
		}

		thinking_scroll_bottom() {
			const node = this.Thinking_parts().dom_node()
			this.scroll_bottom_node( node )
			const id = this.thinking_message_id()
			if( id ) this.thinking_down_visible( id, false )
		}

		scroll_bottom_node( node: Element ) {
			const scroll = ()=> node.scrollTop = node.scrollHeight
			scroll()
			new this.$.$mol_after_frame( scroll )
			new this.$.$mol_after_frame( ()=> new this.$.$mol_after_frame( scroll ) )
			new this.$.$mol_after_timeout( 100, scroll )
		}

		thinking_near_bottom() {
			const node = this.Thinking_parts().dom_node()
			return node.scrollHeight - node.scrollTop - node.clientHeight < 32
		}

		override thinking_scroll( next?: Event ) {
			if( next === undefined ) return null
			const id = this.thinking_message_id()
			if( id ) {
				const stick = this.thinking_near_bottom()
				this.thinking_stick_bottom( id, stick )
				this.thinking_down_visible( id, !stick )
			}
			return next
		}

		override thinking_to_bottom( next?: Event ) {
			if( next === undefined ) return null
			new this.$.$mol_after_frame( ()=> {
				this.thinking_scroll_bottom()
				const id = this.thinking_message_id()
				if( id ) this.thinking_stick_bottom( id, true )
				if( id ) this.thinking_down_visible( id, false )
			} )
			return next
		}

		Thinking_down() {
			const id = this.thinking_message_id()
			return id && this.thinking_down_visible( id ) ? super.Thinking_down() : null as any
		}

		override thinking_close( next?: Event ) {
			if( next === undefined ) return null
			this.thinking_pending( false )
			this.thinking_message_id( '' )
			return next
		}

		thinking_part_by_id( id: string ) {
			return this.thinking_steps()[ Number( id ) ]
		}

		thinking_part_title( id: string ) {
			const step = this.thinking_part_by_id( id )
			if( !step ) return id
			const status = step.finished ? 'завершён' : 'идёт'
			return `${ step.title } · ${ status }`
		}

		thinking_part_text( id: string ) {
			const step = this.thinking_part_by_id( id )
			if( !step ) return ''
			return step.parts
				.filter( part => part.type !== 'step-start' && part.type !== 'step-finish' )
				.map( part => this.thinking_part_text_line( part ) )
				.filter( Boolean )
				.join( '\n\n' )
		}

		thinking_part_rows( id: string ) {
			const step = this.thinking_part_by_id( id )
			if( !step ) return []
			return step.parts.flatMap( ( part, index )=> {
				if( part.type === 'step-start' || part.type === 'step-finish' ) return []
				const key = `${ id }:${ index }`
				return [
					part.type === 'tool'
						? this.Thinking_tool_row( key )
						: part.type === 'reasoning'
							? this.Thinking_plain_row( key )
						: this.Thinking_text_row( key ),
				]
			} )
		}

		thinking_part_part_by_key( key: string ) {
			const divider = key.lastIndexOf( ':' )
			if( divider === -1 ) return null
			const step_id = key.slice( 0, divider )
			const index = Number( key.slice( divider + 1 ) )
			return this.thinking_part_by_id( step_id )?.parts[ index ] ?? null
		}

		thinking_part_text_line_by_key( key: string ) {
			const part = this.thinking_part_part_by_key( key )
			return part ? this.thinking_part_text_line( part ) : ''
		}

		thinking_plain_row_content( key: string ) {
			return [ this.thinking_part_text_line_by_key( key ) ]
		}

		thinking_part_text_line( part: any ) {
			const title = part.type === 'tool' && part.name
				? `tool · ${ part.name }`
				: part.type
			const text = part.type === 'reasoning'
				? this.thinking_reasoning_text( part.text ?? '' )
				: this.part_text( part )
			return [ `### ${ title }`, text ].filter( Boolean ).join( '\n' )
		}

		thinking_reasoning_text( text: string ) {
			const limit = 1000
			if( text.length <= limit ) return text
			const hidden = text.length - limit
			return `... пропущено ${ hidden } символов live-размышлений ...\n${ text.slice( -limit ) }`
		}

		thinking_tool_part( key: string ) {
			const part = this.thinking_part_part_by_key( key )
			return part?.type === 'tool' ? part : null
		}

		thinking_tool_name( key: string ) {
			const part = this.thinking_tool_part( key )
			return part?.name || part?.tool || part?.id || ''
		}

		thinking_tool_status( key: string ) {
			const part = this.thinking_tool_part( key )
			return part?.state?.status || part?.status || ''
		}

		thinking_tool_input( key: string ) {
			const part = this.thinking_tool_part( key )
			return part ? this.tool_input_text( part ) : ''
		}

		thinking_tool_option_rows( key: string ) {
			const part = this.thinking_tool_part( key )
			if( !part || ( part.tool || part.name ) !== 'question' ) return []
			const request = this.question_by_tool_part( part )
			if( !request ) return []
			return request.questions.flatMap( ( question, question_index )=> {
				return question.options.map( ( option, option_index )=> {
					return this.Question_option( `${ request.id }:${ question_index }:${ option_index }` )
				} )
			} )
		}

		question_option_by_key( key: string ) {
			const parts = key.split( ':' )
			const request = this.questions_data().find( question => question.id === parts[0] )
			const question_index = Number( parts[1] )
			const option_index = Number( parts[2] )
			const question = request?.questions[ question_index ]
			const option = question?.options[ option_index ]
			return request && question && option ? { request, question_index, option } : null
		}

		question_option_title( key: string ) {
			return this.question_option_by_key( key )?.option.label ?? ''
		}

		override question_option_reply( key: string, next?: Event ) {
			if( next === undefined ) return null
			const data = this.question_option_by_key( key )
			if( !data ) return next
			const answers = data.request.questions.map( ( question, index )=> {
				return index === data.question_index ? [ data.option.label ] : []
			} )
			this.session_busy( data.request.sessionID, true )
			$mol_wire_async( this ).question_reply_later( data.request.id, answers )
			return next
		}

		question_reply_later( request_id: string, answers: string[][] ) {
			const question = this.questions_data().find( item => item.id === request_id )
			$mol_wire_sync( $shm_hitalama_opencode_api ).question_reply( this.server_url(), request_id, answers )
			if( question?.sessionID ) this.session_busy( question.sessionID, false )
			this.question_remove( request_id )
			const session_id = this.session_id()
			if( session_id ) this.load_messages_later( session_id )
		}

		thinking_tool_content( key: string ) {
			const part = this.thinking_tool_part( key )
			return part ? this.tool_content_text( part ) : ''
		}

		thinking_tool_error( key: string ) {
			const part = this.thinking_tool_part( key )
			return part ? this.tool_error_text( part ) : ''
		}

		download_session( title: string, directory = '' ) {
			const session_id = this.session_id()
			if( !session_id ) return

			const text = this.session_markdown( session_id, title, directory )
			const blob = new Blob( [ text ], { type: 'text/markdown;charset=utf-8' } )
			const url = URL.createObjectURL( blob )
			const link = document.createElement( 'a' )
			link.href = url
			link.download = this.session_file_name( title, session_id )
			link.click()
			URL.revokeObjectURL( url )
		}

		session_markdown( session_id: string, title: string, directory = '' ) {
			const lines = [
				`# ${ title }`,
				'',
				`Session: ${ session_id }`,
				directory ? `Directory: ${ directory }` : '',
				'',
			].filter( line => line !== '' )

			for( const message of this.messages_data( session_id ) ) {
				const time = message.info.time?.created
					? new Date( message.info.time.created ).toLocaleString()
					: ''
				const role = message.info.role || message.info.type || 'message'
				const model = message.info.model?.modelID || message.info.model?.id || message.info.modelID
				const meta = [ role, model, time ].filter( Boolean ).join( ' · ' )
				lines.push( `## ${ meta }`, '' )
				lines.push( this.message_text_export( message ), '' )
			}

			return `${ lines.join( '\n' ).trim() }\n`
		}

		message_text_export( message: $shm_hitalama_opencode_api_message ) {
			return message.parts.map( part => this.part_text( part ) ).filter( Boolean ).join( '\n\n' )
		}

		session_file_name( title: string, session_id: string ) {
			const safe = title.toLowerCase()
				.replace( /[\\/:*?"<>|]+/g, '-' )
				.replace( /\s+/g, '-' )
				.replace( /-+/g, '-' )
				.replace( /^-|-$/g, '' )
			return `${ safe || session_id || 'opencode-session' }.md`
		}

		part_text( part: any ): string {
			if( part.type === 'text' ) return part.text ?? ''
			if( part.type === 'reasoning' ) return part.text ? `> ${ part.text }` : ''
			if( part.type === 'tool' ) return this.tool_text( part )
			if( part.type === 'file' ) return `Файл: ${ part.filename || part.url || part.uri || part.id }`
			if( part.type === 'patch' ) return part.files ? `Patch: ${ part.files.join( ', ' ) }` : 'Patch'
			if( part.type === 'snapshot' ) return `Snapshot: ${ part.snapshot || part.id }`
			if( part.type === 'step-start' ) return 'Шаг начат'
			if( part.type === 'step-finish' ) return 'Шаг завершен'
			return JSON.stringify( part, null, '\t' )
		}

		tool_text( part: any ) {
			const state = part.state ?? {}
			const status = state.status || part.status ? ` · ${ state.status || part.status }` : ''
			return [
				`Tool: ${ part.name || part.tool || part.id }${ status }`,
				this.tool_input_text( part ),
				this.tool_content_text( part ),
				this.tool_error_text( part ),
			].filter( Boolean ).join( '\n' )
		}

		tool_step_text( part: any ) {
			const state = part.state ?? {}
			const status = state.status || part.status ? ` · ${ state.status || part.status }` : ''
			return [
				`Tool: ${ part.name || part.tool || part.id }${ status }`,
				this.tool_input_text( part ),
			].filter( Boolean ).join( '\n\n' )
		}

		tool_input_text( part: any ) {
			const input = part.state?.input ?? part.input
			if( input == null || input === '' ) return ''

			const questions = input?.questions
			if( Array.isArray( questions ) ) {
				return questions.map( ( question: any )=> {
					const options = Array.isArray( question.options )
						? question.options.map( ( option: any )=> {
							return `- ${ option.label || option.value || '' }${ option.description ? `: ${ option.description }` : '' }`
						} ).filter( Boolean ).join( '\n' )
						: ''
					return [
						question.header,
						question.question,
						options,
					].filter( Boolean ).join( '\n' )
				} ).filter( Boolean ).join( '\n\n' )
			}

			return this.value_text( input )
		}

		tool_content_text( part: any ) {
			const content = part.state?.content ?? part.content
			if( content == null || content === '' ) return ''
			if( Array.isArray( content ) ) {
				return content.map( ( item: any )=> {
					return item?.text || item?.uri || item?.name || this.value_text( item )
				} ).filter( Boolean ).join( '\n' )
			}
			return this.value_text( content )
		}

		tool_error_text( part: any ) {
			const error = part.state?.error ?? part.error
			if( error == null || error === '' ) return ''
			return error.message || this.value_text( error )
		}

		value_text( value: any ) {
			if( value == null || value === '' ) return ''
			if( typeof value === 'string' ) return value
			return JSON.stringify( value, null, '\t' )
		}

		thinking_open_on_send() {
			return true
		}

		agent_id() {
			return ''
		}

		session_id_ensure( model = this.model_current() ) {
			const stored = this.session_id()
			if( stored ) return stored

			const session = $mol_wire_sync( $shm_hitalama_opencode_api ).create_session(
				this.server_url(),
				'Новая сессия',
				model,
			) as $shm_hitalama_opencode_api_session
			this.session_id( session.id )
			return session.id
		}

		session_context_sync( session_id: string ) {
			// Hook for embedded contexts that bind a remote agent session to a local MCP scope.
		}

		override export_session( next?: any ) {
			if( next === undefined ) return null
			this.download_session( this.chat_title() )
			return next
		}

		send( next?: any ) {
			if( next === undefined ) return null
			const text = this.prompt().trim()
			if( !text ) return next

			this.prompt( '' )
			$mol_wire_async( this ).send_later( text ).catch( error => $mol_fail_log( error ) )
			return next
		}

		send_button_content() {
			const session_id = this.session_id()
			return session_id && this.session_busy( session_id )
				? [ this.Stop_icon() ]
				: [ this.Send_icon() ]
		}

		send_button_click( next?: any ) {
			if( next === undefined ) return null
			const session_id = this.session_id()
			if( session_id && this.session_busy( session_id ) ) return this.stop( next )
			return this.send( next )
		}

		stop( next?: any ) {
			if( next === undefined ) return null
			const session_id = this.session_id()
			if( !session_id ) return next

			this.session_busy( session_id, false )
			this.thinking_pending( false )
			$mol_wire_async( this ).stop_later( session_id ).catch( error => $mol_fail_log( error ) )
			return next
		}

		stop_later( session_id: string ) {
			$mol_wire_sync( $shm_hitalama_opencode_api ).abort_session(
				this.server_url(),
				session_id,
			)
			this.load_messages_soon( session_id )
		}

		send_later( text: string ) {
			const model = this.model_current()
			const no_reply = this.no_reply()
			const agent = this.agent_id()
			const previous_session_id = this.session_id()

			if( !this.no_reply() && this.thinking_open_on_send() ) {
				this.thinking_pending( true )
				this.thinking_message_id( 'pending' )
				this.thinking_anchor_index( previous_session_id ? this.messages_cached( previous_session_id ).length : 0 )
			}

			const session_id = this.session_id_ensure( model )
			this.session_context_sync( session_id )
			this.message_local_user_upsert( session_id, text )
			if( !no_reply ) this.session_busy( session_id, true )
			$mol_wire_sync( $shm_hitalama_opencode_api ).send_prompt(
				this.server_url(),
				session_id,
				text,
				model,
				no_reply,
				agent,
			)
			if( !no_reply ) this.session_busy( session_id, false )
			this.load_messages_soon( session_id )
		}

	}

}
